"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapchatIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const GhostIcon_1 = require("../GhostIcon");
/** Snapchat icon for the share bar */
function SnapchatIcon() {
    return (0, jsx_runtime_1.jsx)(GhostIcon_1.GhostIconWithCircularBg, { width: 32, height: 32 });
}
exports.SnapchatIcon = SnapchatIcon;
//# sourceMappingURL=SnapchatIcon.js.map